import { Form } from '@/components/ui/form'
import { Button } from '@/components/ui/button'
import { ReactNode, useState } from 'react'
import { useModalWizardStepsContext } from './ModalWizardStepsContext'
import { DialogFooter } from '@/components/ui/dialog'
import { Modal, ModalProps } from '../Modal'
import { StepsComponent } from '../StepsComponent'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import ButtonLoading from '@/components/misc/Button'

interface IStep {
  name: string
  actionButtons: {
    label: string
    secondaryAction?: () => void
    primaryAction?: (data: any) => void
  }[]
  component: ReactNode
}

interface IModalWizzardStepsProps extends Omit<ModalProps, 'footer'> {
  title?: string
  subtitle?: string
  currentStep: number
  isOpen: boolean
  onClose: Function
  steps: IStep[]
  size?: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'
  modalClassName?: string
  isSending: boolean
  confirmOnClose?: boolean
}

export function ModalWizardSteps({
  currentStep,
  steps,
  isOpen,
  onClose,
  title,
  subtitle,
  size,
  modalClassName,
  isSending,
  confirmOnClose = false,
}: IModalWizzardStepsProps) {
  const { useFormWizzard } = useModalWizardStepsContext()
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      size={size}
      modalClassName={modalClassName}
      confirmOnClose={confirmOnClose}
    >
      <StepsComponent
        steps={steps.map((item) => item.name)}
        currentStep={currentStep}
      />
      <Form {...useFormWizzard}>
        <div className={'flex flex-col overflow-y-scroll px-2 scrollbar-thin'}>
          {steps[currentStep].component}
        </div>
        <DialogFooter className="flex-shrink-0 flex-col-reverse gap-2 border-t px-4 pt-4 sm:flex-row sm:justify-between sm:px-6">
          <Footer
            step={steps[currentStep]}
            onClose={onClose}
            isSending={isSending}
          />
        </DialogFooter>
      </Form>
      {/* Eliminada la confirmación de cancelación */}
    </Modal>
  )
}

interface IFooterProps {
  step: IStep
  onClose: Function
  isSending: boolean
}

function Footer({
  step,
  onClose,
  isSending,
}: IFooterProps) {
  const { useFormWizzard } = useModalWizardStepsContext()
  const { handleSubmit } = useFormWizzard

  return (
    <>
      <div>
        <Button
          disabled={isSending}
          variant="outline"
          onClick={() => onClose(false)}
        >
          Cancelar
        </Button>
      </div>
      <div className={'flex gap-2'}>
        {step.actionButtons.map((btn, index) =>
          isSending && index === 1 ? (
            <ButtonLoading
              key={`loading-${index}`}
              loading={isSending}
              name="Guardando..."
            ></ButtonLoading>
          ) : (
            <Button
              key={`button-${index}-${btn.label}`}
              disabled={isSending}
              variant={
                index === step.actionButtons.length - 1 ? 'default' : 'outline'
              }
              onClick={
                btn.primaryAction
                  ? handleSubmit(btn.primaryAction)
                  : btn.secondaryAction
              }
            >
              {btn.label}
            </Button>
          )
        )}
      </div>
    </>
  )
}
